module.exports = __webpack_public_path__ + "img/kwaiLogo@2.e9a678e.png";